import React, { useState, useEffect, useRef } from "react";
import M from "materialize-css";
import AOS from "aos";
import "./PageContato.css";
import "aos/dist/aos.css";

const QAList = ({ items }) => {
  useEffect(() => {
    const elems = document.querySelectorAll(".collapsible");
    M.Collapsible.init(elems);
  }, []);

  return (
    <div className="collapsible-wrapper">
      <ul className="collapsible collapsible-contato">
        {items.map((item, index) => (
          <li key={index}>
            <div className="collapsible-header contato">
              {item.pergunta}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
            <div className="collapsible-body contato">
              <p className="question-page-contato">{item.resposta}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const QASection = ({ qaListCol1, qaListCol2 }) => {
  return (
    <div id="perguntasContato" className="container-qa">
      <h5 className="h5-contato-qea">
        10 perguntas para fazer a si mesma antes de uma cirurgia plástica
      </h5>
      <div className="container-contato flex">
        <div className="col col1-contato">
          <QAList items={qaListCol1} />
        </div>
        <div className="col col2-contato">
          <QAList items={qaListCol2} />
        </div>
      </div>
    </div>
  );
};

function PageContato() {
  const [backgroundImage, setBackgroundImage] = useState(
    "/images/banner-contato/banner_contato_desktop.webp"
  );
  const parallaxRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setBackgroundImage("/images/banner-contato/contato_mobile.webp");
      } else if (window.innerWidth <= 1024) {
        setBackgroundImage("/images/banner-contato/contato_tablet.webp");
      } else {
        setBackgroundImage(
          "/images/banner-contato/banner_contato_desktop.webp"
        );
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    AOS.init({
      duration: 300,
      easing: "ease-out",
      once: true,
    });

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const parallaxElement = parallaxRef.current;

    const handleScroll = () => {
      if (parallaxElement) {
        const scrollPosition = window.scrollY;
        parallaxElement.style.transform = `translateY(${scrollPosition * 0.3}px)`;
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const qaListCol1 = [
    {
      pergunta: "O que desejo mudar em minha aparência?",
      resposta:
        "É ideal que você tenha clareza sobre os aspectos que deseja melhorar e saiba explicar ao cirurgião o que a incomoda.",
    },
    {
      pergunta: "Estou em boa saúde para passar por uma cirurgia?",
      resposta:
        "É importante realizar exames médicos e assegurar-se de que está saudável e apta para um procedimento cirúrgico.",
    },
    {
      pergunta: "Estou fazendo isso por mim ou por influência externa?",
      resposta:
        "A decisão deve ser pessoal e baseada em seu desejo genuíno, não em pressões sociais ou de outras pessoas.",
    },
    {
      pergunta: "Pesquisei sobre o procedimento e alternativas?",
      resposta:
        "O ideal é estar informada sobre o procedimento, as técnicas disponíveis e possíveis alternativas para alcançar seus objetivos.",
    },
    {
      pergunta: "Estou disposta(o) a seguir todas as orientações médicas?",
      resposta:
        "A disposição para seguir orientações pré e pós-operatórias é essencial para um bom resultado e recuperação segura.",
    },
  ];

  const qaListCol2 = [
    {
      pergunta: "Minhas expectativas são realistas?",
      resposta:
        "As expectativas devem ser alinhadas com os resultados possíveis, considerando as características individuais do seu corpo e a técnica escolhida.",
    },
    {
      pergunta: "Tenho plena consciência dos riscos envolvidos?",
      resposta:
        "Você deve compreender os riscos do procedimento e aceitar que, além das cicatrizes, eles fazem parte de qualquer intervenção cirúrgica.",
    },
    {
      pergunta: "Estou preparada(o) para o tempo de recuperação?",
      resposta:
        "É essencial compreender e aceitar o tempo necessário para a recuperação total, ajustando expectativas e compromissos pessoais e profissionais.",
    },
    {
      pergunta: "Tenho apoio emocional e financeiro para este processo?",
      resposta:
        "O suporte emocional é vital para lidar com o processo, assim como a segurança financeira para arcar com os custos e imprevistos.",
    },
    {
      pergunta: "Confio plenamente no cirurgião e em sua experiência?",
      resposta:
        "A confiança no cirurgião é fundamental. Pesquise o histórico, credenciais e depoimentos de outros pacientes.",
    },
  ];

  return (
    <>
      <section id="bannerContato">
        <div className="parallax-container">
          <div
            className="parallax"
            style={{ backgroundImage: `url(${backgroundImage})` }}
            ref={parallaxRef}
          ></div>
          <div className="bannerContato-text">
            <h2
              className="titulo-bannerContato"
              data-aos="fade-up"
              data-aos-duration="300"
            >
              Agende uma consulta com o <br />
              <br />
              Dr. Luciano Gazzoni
            </h2>
            <p
              className="banner-contato-1"
              data-aos="fade-up"
              data-aos-duration="300"
            >
              Sua confiança, nossa missão:{" "}
            </p>
            <p
              className="banner-contato-2"
              data-aos="fade-up"
              data-aos-duration="300"
            >
              <span className="bold-text">excelência</span> em cirurgia
              plástica.
            </p>
            <div
              className="bannerContato-btn-container"
              data-aos="fade-up"
              data-aos-duration="100"
            >
              <a
                href="https://api.whatsapp.com/send/?phone=5561986253859&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bannerContato-btn">
                  Agende sua consulta
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="contatoPerguntas">
        <div className="container-description">
          <h3 id="titulo-contato" data-aos="fade-up" data-aos-duration="300">
            Encontre a transformação que você merece
          </h3>
          <h5 className="h5-contato" data-aos="fade-up" data-aos-duration="300">
            Refletindo sobre a sua jornada
          </h5>
          <p
            className="contato-description"
            data-aos="fade-up"
            data-aos-duration="300"
          >
            Antes de decidir por uma cirurgia estética, é essencial fazer uma
            autoavaliação. Reserve um momento para refletir sobre suas
            expectativas e objetivos. A cirurgia plástica é um passo importante,
            e queremos que você se sinta segura(o) e preparada(o). Estamos aqui
            para guiá-la(o) em cada etapa, com respeito, transparência e
            cuidado.
          </p>
        </div>

        <QASection qaListCol1={qaListCol1} qaListCol2={qaListCol2} />
      </section>
    </>
  );
}

export default PageContato;
